// removed by extract-text-webpack-plugin
module.exports = {"modal":"src-components-Kolofon----kolofon-module---modal---2pzeP","showModal":"src-components-Kolofon----kolofon-module---showModal---2niqI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Kolofon/kolofon.module.scss
// module id = 303
// module chunks = 168707334958949